import axios from "axios";


const domain = process.env.REACT_APP_API_URL;

const submitFormData = (formData) => {
  return axios.post(`${domain}/users/register`, formData, {
    timeout: 5000,
  });
};

export default submitFormData;
